import PropTypes from 'prop-types';
import { Button } from 'react-bootstrap'
import * as styles from './_EditProfileButton.scss'
import React from 'react';

const EditProfileButton = ({
  buttonText
  , size
  , onClick
  , isDisabled
}) => (
  <Button type='submit'
    variant={'primary'}
    size={size}
    onClick={onClick}
    className={styles['right-align']}
    disabled={isDisabled}>
    <span>{buttonText}</span>
  </Button>)

EditProfileButton.propTypes = {
  buttonText: PropTypes.string.isRequired,
  size: PropTypes.string.isRequired,
  onClick: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool
}

export default (EditProfileButton)
